import axios from 'axios'

const VehicleService = {
  async get (params = {}) {
    return axios.get('lo/vehicles', { params })
  },

  async post (params = {}) {
    return axios.post('lo/vehicles', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/vehicles/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/vehicles/${data.id}`, { data })
  }
}

export default VehicleService
